/** Highlight field `type` from CMS (e.g. expertise_item) → display title */
export function formatHighlightFieldTitle(type: string): string {
  const base = type
    .replace(/_item$/i, '')
    .replace(/_/g, ' ')
    .trim();
  if (!base) return type;
  return base.replace(/\b\w/g, (char) => char.toUpperCase());
}
